import {
  accountStatusUpdated,
  appSync,
  startListening,
} from '@betty/toolkit/state';
import {
  depositApproved,
  getDepositCount,
  selectHasUserDeposited,
} from '@betty/wallet';
import {
  claimDailyGift,
  fetchDailyGift,
  selectDailyGift,
  selectDailyGiftDataState,
} from './dailyGift.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch, getState }) => {
    const dataState = selectDailyGiftDataState(getState());

    if (dataState === 'fulfilled' || dataState === 'rejected') {
      dispatch(fetchDailyGift());
    }
  },
});

startListening({
  actionCreator: claimDailyGift.fulfilled,
  effect: (_, { dispatch }) => {
    dispatch(fetchDailyGift());
  },
});

startListening({
  actionCreator: depositApproved,
  effect: (_, { dispatch, getState }) => {
    const { status: dailyGiftStatus } = selectDailyGift(getState()) || {};
    if (dailyGiftStatus === 'NotAvailable') {
      dispatch(fetchDailyGift());
    }
  },
});

startListening({
  actionCreator: accountStatusUpdated,
  effect: (_, { dispatch }) => {
    dispatch(fetchDailyGift());
  },
});

startListening({
  actionCreator: getDepositCount.fulfilled,
  effect: (_, { dispatch, getState, getOriginalState }) => {
    const hasPrevDeposited = selectHasUserDeposited(getOriginalState());
    const hasNowDeposited = selectHasUserDeposited(getState());

    if (!hasPrevDeposited && hasNowDeposited) {
      dispatch(fetchDailyGift());
    }
  },
});
